import containerFuild from '../html-snippets/container-fuild';
import css from '../css-snippets/section-marquee-rivoneed';
const html = `
<div class="wrap-card">
  <div data-show="true" data-attribute="card-title" class="card-title">
    <h2 style="text-align: center">Tough Enough for Real Work</h2>
    <p style="text-align: center">IK08 impact resistance and IPX4 water protection for reliable performance</p>
  </div>
  <div
    class="block-marquee"
    data-width-item="320"
    data-gap-item="15"
    data-border-radius-item="10"
    data-color-border-item="#ffffff"
    data-speed-marquee="20"
    data-attribute="block-marquee"
    style="
      --width-item: 320px;
      --gap-item: 15px;
      --border-radius-item: 10px;
      --color-border-item: #ffffff;
      --speed-marquee: 20s;
    "
  >
    <div data-attribute="list-item" class="list-item">
      <div
        data-attribute="item-marquee"
        class="item-marquee"
        data-color-overlay="#000000"
        data-opacity-overlay="0.8"
        style="--color-overlay: #000000; --opacity-overlay: 0.8"
      >
        <img
          data-attribute="image-item"
          src="https://cdn.skyfastimg.com/images/2026/06/15/image-6a2f755e5ddf372832fa4eaa.webp"
          alt=""
        />
        <div data-attribute="content-item" class="wrap-content">
          <h3>Under-Hood Work</h3>
        </div>
      </div>

      <div
        data-attribute="item-marquee"
        class="item-marquee"
        data-color-overlay="#000000"
        data-opacity-overlay="0.1"
        style="--color-overlay: #000000; --opacity-overlay: 0.1"
      >
        <img
          data-attribute="image-item"
          src="https://cdn.skyfastimg.com/images/2026/06/15/image-6a2f7566758f6c1c1b19b61f.webp"
          alt=""
        />
        <div data-attribute="content-item" class="wrap-content">
          <h3>Roadside Rain Repair</h3>
        </div>
      </div>

      <div
        data-attribute="item-marquee"
        class="item-marquee"
        data-color-overlay="#000000"
        data-opacity-overlay="0.1"
        style="--color-overlay: #000000; --opacity-overlay: 0.1"
      >
        <img
          data-attribute="image-item"
          src="https://cdn.skyfastimg.com/images/2026/06/15/image-6a2f756fea83db638a55dd6a.webp"
          alt=""
        />
        <div data-attribute="content-item" class="wrap-content">
          <h3>Under-Car Inspection</h3>
        </div>
      </div>

      <div
        data-attribute="item-marquee"
        class="item-marquee"
        data-color-overlay="#000000"
        data-opacity-overlay="0.1"
        style="--color-overlay: #000000; --opacity-overlay: 0.1"
      >
        <img
          data-attribute="image-item"
          src="https://cdn.skyfastimg.com/images/2026/06/15/image-6a2f7579da6be8fd748ce821.webp"
          alt=""
        />
        <div data-attribute="content-item" class="wrap-content">
          <h3>Full-Day Garage Work</h3>
        </div>
      </div>

      <div
        data-attribute="item-marquee"
        class="item-marquee"
        data-color-overlay="#000000"
        data-opacity-overlay="0.1"
        style="--color-overlay: #000000; --opacity-overlay: 0.1"
      >
        <img
          data-attribute="image-item"
          src="https://cdn.skyfastimg.com/images/2026/06/15/image-6a2f7583b9e45b2482a2a2c3.webp"
          alt=""
        />
        <div data-attribute="content-item" class="wrap-content">
          <h3>Home Power Outage</h3>
        </div>
      </div>

      <div
        data-attribute="item-marquee"
        class="item-marquee"
        data-color-overlay="#000000"
        data-opacity-overlay="0.1"
        style="--color-overlay: #000000; --opacity-overlay: 0.1"
      >
        <img
          data-attribute="image-item"
          src="https://cdn.skyfastimg.com/images/2026/06/15/image-6a2f7591dcfc61302d6ed75b.webp"
          alt=""
        />
        <div data-attribute="content-item" class="wrap-content">
          <h3>Camping Overnight</h3>
        </div>
      </div>
    </div>
  </div>
</div>
`;
export default containerFuild(html, css, {
  backgroundColor: '#1a1a1a',
  textColor: '#ffffff',
});
